<template>
    <el-row align="center" v-if="!disabled" id="body_content" v-loading="loading">
        <el-row class="row" id="title_wrapper">
            <span @click="backToMyPage" id="back_button"><i class="el-icon el-icon-arrow-left"></i></span>
            <label id="change_email_title">{{$t('changeEmail.changeEmailTitle')}}</label>
        </el-row>
        <h3 id="change_email_description">{{$t("changeEmail.changeEmailDescription")}}</h3>

        <div style="margin-top: 20px">
            <el-form class="flex-1 register-form customize-label-top-form"
                     :rules="rules"
                     :model="formData"
                     ref="registerForm">
                <el-form-item prop="email" :label="$t('changeEmail.emailAddressTitle')" style="font-weight: bold">
                    <el-input v-model="formData.email" ref="email" type="text" @change="checkDisableConfirmButton"
                              :placeholder="$t('changeEmail.emailAddressPlaceholder')"
                              autocomplete="disabled"
                              aria-autocomplete="none"></el-input>
                    <p style="color: red; margin-top: -10px; margin-bottom: 0px" v-show="">
                        {{$t("common.requiredMessage")}}</p>
                </el-form-item>
            </el-form>
        </div>

        <div>
            <el-row id="confirm_button_wrapper">
                <el-button id="confirm_button" :disabled="disableConfirmButton" @click="sendEmailToConfirm">
                    {{$t("changeEmail.confirmButton")}}
                </el-button>
            </el-row>

            <el-row id="bottom_back_button_wrapper">
                <el-button id="bottom_back_button" @click="backToMyPage">{{$t("changeEmail.backButton")}}</el-button>
            </el-row>
        </div>

    </el-row>
</template>

<script>
    import Pages from "../../../router/Pages";
    import UserAPI from "../../../api/user/UserApi";
    import AlertService from "../../../service/alert.service";

    export default {
        name: "EnterNewEmailAddress",

        data() {
            return {
                rules: {
                    email: [
                        {required: true, message: this.$t("common.requiredMessage"), trigger: "blur"},
                        {type: "email", message: this.$t('register.pleaseEnterExactlyFormatEmail'), trigger: "blur"},
                    ],
                },

                email: null,
                disabled: false,
                formData: {
                    email: null,
                },

                loading: false,

                disableConfirmButton: true,
            }
        },

        created() {
            this.disabled = false;
        },

        methods: {
            checkDisableConfirmButton() {
                if (this.formData.email == null || this.formData.email.trim() == "" || !this.validateEmailFormat(this.formData.email)) {
                    this.disableConfirmButton = true;
                } else {
                    this.disableConfirmButton = false;
                }
            },

            backToMyPage() {
                this.$router.push({path: "/myPage"})
            },

            validateEmailFormat(email) {
                let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            sendEmailToConfirm() {
                this.loading = true;
                UserAPI.checkEmailWasActivatedOrIsConfirming(this.formData.email).then(result => {
                    if (result) {
                        this.loading = false;
                        AlertService.error(this.$t("register.emailWasUsedMessage"))
                    } else {
                        UserAPI.sendEmailToConfirmChanging(this.formData.email).then(result => {
                            //redirect to send email display
                            this.loading = false;
                            this.$emit('showConfirm', this.formData.email);
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    #body_content {
        width: 40%;
        margin-left: 30%;
    }

    #title_wrapper {
        margin-top: 50px;
    }

    #back_button {
        margin-left: -20px;
        position: absolute;
        cursor: pointer;
        font-size: 30px;
        font-weight: bold;
        z-index: 1;
    }

    #change_email_title {
        font-weight: bold;
        font-size: 30px;
        position: relative;
        display: inline-block;
        width: calc(80% - 50px);
        margin: 0 calc(10% + 25px);
        text-align: center;
    }

    #confirm_button_wrapper {
        text-align: center;
        width: 100%;
        margin-top: 50px
    }

    #confirm_button {
        width: 60%;
        background-color: #4B86E8;
        color: white
    }

    #bottom_back_button_wrapper {
        margin-top: 15px;
        text-align: center;
        width: 100%
    }

    #bottom_back_button {
        width: 60%
    }

    #change_email_description {
        text-align: center;
    }

    @media only screen and (max-width: 1024px) {
        #body_content {
            width: 80%;
            margin-right: 10%;
            margin-left: 10%;
        }
    }


    @media only screen and (max-width: 450px) {
        #body_content {
            width: 100%;
            margin-right: 0%;
            margin-left: 0%;
        }

        #title_wrapper {
            margin-top: 30px;
        }

        #confirm_button_wrapper {
            width: 100%;
            margin-top: 35px
        }

        #confirm_button {
            width: 100%;
            background-color: #4B86E8;
            color: white
        }

        #bottom_back_button_wrapper {
            margin-top: 15px;
            width: 100%
        }

        #bottom_back_button {
            width: 100%
        }

        #change_email_title {
            font-size: 21px;
        }

        #back_button {
            font-size: 21px;
            margin-left: 15px;
            margin-top: 5px;
            margin-bottom: 5px;
        }

        #change_email_description {
            text-align: center;
            font-size: 97%;
            margin-top: 25px;
        }

    }

    @media only screen and (max-width: 360px) {
        #change_email_title {
            font-size: 17.4px;
        }

        #title_wrapper {
            margin-top: 20px;
        }

        #confirm_button_wrapper {
            margin-top: 25px
        }

        #change_email_description {
            text-align: center;
            font-size: 95%;
        }

        #back_button {
            font-size: 19px;
            margin-left: 13px;
            margin-top: 2px;
            margin-bottom: 2px;
        }

    }

</style>